// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"20e09249","453":"7548a984","462":"365539e1","472":"15d925c0","599":"3b790567","663":"ee0cd3a1","764":"f82db22e"}[chunkId] + ".chunk.js";
};